import styled from '@emotion/styled';
import { keyframes } from '@emotion/react/macro';

const flash = keyframes`
  0% {
  background-color: var(--placeholder-color-0);
}
  50% {
  background-color: var(--placeholder-color-50);
}
  100% {
  background-color: var(--placeholder-color-100);
}
`;

export const AnimatedPlaceholder = styled.div`
  background-color: var(--placeholder-color-0);
  animation: ${flash} 1.3s infinite;
  animation-delay: ${(props) => props.delay || '1s'};
`;

export const ItemPlaceholder = styled.div`
  display: flex;
  padding-top: 4px;
  border-radius: 4px;
`;
export const Columns = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0 10px 0 5px;
`;
export const Title = styled(AnimatedPlaceholder)`
  width: ${(props) => props.width}%;
  height: 18px;
  line-height: 20px;
  border-radius: 50px;
`;
export const Footer = styled(AnimatedPlaceholder)`
  width: 100px;
  height: 10px;
  margin-top: 5px;
  line-height: 20px;
  border-radius: 50px;
`;
export const CardName = styled(AnimatedPlaceholder)`
  width: ${(props) => props.width}%;
  height: 14px;
  margin-top: 5px;
  line-height: 20px;
  border-radius: 50px;
`;
export const Divider = styled.hr`
  margin: 10px 0 0;
  width: 100%;
  background-color: var(--border);
`;
